import { createFileRoute, Link } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import Footer from '../components/Footer';
import { usePageMeta } from '../hooks/usePageMeta';

export const Route = createFileRoute('/$')({
  component: NotFoundComponent,
});

const GOLD = '#a07d3a';

function NotFoundComponent() {
  usePageMeta(
    'Page Not Found | Boyden Renovations',
    'The page you are looking for does not exist.'
  );

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.nf-item',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          ease: 'power2.out',
          stagger: 0.15,
          delay: 0.1,
        }
      );
    }, containerRef);
    return () => ctx.revert();
  }, []);

  return (
    <div data-nav-theme="light">
      <div
        ref={containerRef}
        className="flex flex-col items-center justify-center min-h-screen bg-neutral px-6 text-center"
      >
        <p
          className="nf-item text-[8rem] md:text-[12rem] leading-none font-serif font-light"
          style={{ color: GOLD, opacity: 0 }}
        >
          404
        </p>

        <div
          className="nf-item flex items-center gap-4 w-full max-w-xs my-6"
          style={{ opacity: 0 }}
        >
          <div className="h-px flex-1" style={{ background: GOLD }} />
          <div
            className="size-1.5 shrink-0 rotate-45"
            style={{ background: GOLD }}
          />
          <div className="h-px flex-1" style={{ background: GOLD }} />
        </div>

        <h1
          className="nf-item text-2xl md:text-3xl font-serif tracking-widest text-neutral-dark mb-4"
          style={{ opacity: 0 }}
        >
          Page Not Found
        </h1>

        <p
          className="nf-item font-sans font-light tracking-wide text-neutral-dark/70 max-w-sm mb-10"
          style={{ opacity: 0 }}
        >
          The page you're looking for doesn't exist or may have moved.
        </p>

        <Link
          to="/"
          className="nf-item uppercase font-sans font-light tracking-[4px] text-neutral py-3 px-10 transition-colors duration-200"
          style={{ background: '#00391F', opacity: 0 }}
        >
          Return Home
        </Link>
      </div>

      <Footer isLoaded />
    </div>
  );
}
